import { render, staticRenderFns } from "./EmbeddedImageGallery.vue?vue&type=template&id=3039d81f"
import script from "./EmbeddedImageGallery.vue?vue&type=script&lang=js"
export * from "./EmbeddedImageGallery.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedImageGallery.vue?vue&type=style&index=0&id=3039d81f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports